import { Injectable } from "@angular/core";
import { TokenAcessoEditor, TokenLogin } from "src/app/shared/models/login-response";
import { environment } from "src/environments/environment";
import { TokenEditorService } from "./token-editor.service";

export class EditorAppRoutes {
  public static getEdicaoRoute(processamentoSpedId: number): string {
    return `/loader/${processamentoSpedId}`;
  }
}
@Injectable({
  providedIn: "root",
})
export class NavigationService {
  constructor(
    private tokenEditorService: TokenEditorService
  ) {}

  navigateToEditorApp(tokenLogin?: TokenLogin, url?: string): void {
    let targetUrl = `${environment.editorUrl}`;
    if (tokenLogin) {
      const tokenAcessoEditor: TokenAcessoEditor = this.tokenEditorService.gerarTokenAcessoEditor(tokenLogin);
      
      if (url) {
        targetUrl = `${targetUrl}${url}`;
      }
      
      const serializedToken = encodeURIComponent(JSON.stringify(tokenAcessoEditor));
      targetUrl = `${targetUrl}?token=${serializedToken}`;
    } else if (url) {
      targetUrl = `${targetUrl}${url}`;
    }

    window.location.href = targetUrl;
  }
}
